import { useSnackbar } from 'notistack5';
// React から useEffect フックをインポート
import { useEffect } from 'react';
// react-i18next から useTranslation フックをインポート
import { useTranslation } from 'react-i18next';
// react-router-dom から useLocation、useParams フックをインポート
import { useLocation, useParams } from 'react-router-dom';
import { HeaderBreadcrumbsProps } from 'src/components/HeaderBreadcrumbs';
// Enquete単位のページで共通的に行いたい処理を記述するコンポーネントをインポート
import { EnquetePageComponent } from 'src/components/app-components/bonsai/EnquetePageComponent';
import { API_PATH } from '../../routes/generalPath';
// コンプライアンス・レビュー カレンダー予定登録画面の全体を管理するコンポーネントをインポート
import { CalendarCreateLayout } from '../components/CalendarCreateLayout';

export interface EnqueteCreatePageProps {}

export interface NotificateStateTypes {
  duplicated?: boolean;
}

export const CalendarCreatePage = () => {
  const { calendarId } = useParams();
  const linkState: unknown = useLocation().state;
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const createdListTitle = t('enqueteCalendarList.pageTitle');
  const title = t('CalendarCreate.pageTitle');
  const permissionParam = {};

  const breadCrumbs: HeaderBreadcrumbsProps = {
    heading: title,
    links: [
      { name: 'TOP', href: '/top' },
      { name: createdListTitle, href: API_PATH.ENQUETE_CALENDAR },
    ],
    activeLast: true,
  };

  //通知
  const notificateDuplicateSurvey = () => {
    //useNavigateのステートを変数へ格納
    if (typeof linkState !== 'object' || linkState === null) return;

    const state = linkState as NotificateStateTypes;
    if (state.duplicated !== undefined && state.duplicated === true)
      enqueueSnackbar(t('enqueteCreate.message.duplicatedSurvey'), { variant: 'success' });
  };

  useEffect(() => {
    notificateDuplicateSurvey();
  }, []); //eslint-disable-line

  return (
    <EnquetePageComponent permissionParam={permissionParam}>
      <CalendarCreateLayout id={calendarId} pageTitle={title} breadCrumbs={breadCrumbs} />
    </EnquetePageComponent>
  );
};
